import { CSSTransition, React, Styled } from '@common/3rd';
import { DeskComponentRegistry, ModelContainerWidget } from '@component';
import { Utils } from '@common';

type DeskTabProps = {
	titles: string[];
	headClick?: (options: { invoker: any, root: any, model: any, index: number }) => {};
};
type DeskTabState = {
	index?: number;
};
type DeskTabComponents = {
	Box: any;
	Headers: any;
	Header: any;
	Contents: any;
	Content: any;
};

/**
 * 页签
 */
class DeskTab<
	P extends DeskTabProps,
	S extends DeskTabState,
	C extends DeskTabComponents
	> extends ModelContainerWidget<P, S, C> {


	protected initComponents(): C {
		return {
			Box: Styled.div.attrs({
				'data-widget': 'desk-tab'
			})`
				display: flex;
				flex-direction: column;
				max-width: 100vw;
				border: solid 1px;
				border-color: lightgrey;
				border-radius: 4px;
				${props => this.renderCSS(props.theme)}
			`,
			Headers: Styled.div.attrs({
				'data-widget': 'desk-tab-headers'
			})`
				width: 100%;
				display: grid;
				position: relative;
				grid-template-columns: ${(props: any) =>
					new Array(props.count).fill('1fr').join(' ')};
				div {
					div{
						word-break: keep-all;
					}
					&:not(:last-child) {
						div{
							// margin-bottom: 5px;
							// border-right: 1px solid ${props => props.theme.COLOR_PRIMARY};
						}
					}
				}	
				// &:after {
				// 	content: '';
				// 	display: block;
				// 	position: absolute;
				// 	width: ${(props: any) => (1 / props.count) * 100}%;
				// 	left: 0;
				// 	bottom: 0;
				// 	border-bottom: ${props => props.theme.BORDER};
				// 	border-color: ${props => props.theme.COLOR_PRIMARY};
				// 	transition: left 100ms ease-in-out;
				// 	left: ${(props: any) => (props.activeIndex / props.count) * 100}%;
				// }
				${(props: any) => {
					return `
						> div {
							color: #555;
							background: ${props.theme.COLOR_PRIMARY_LIGHT_010};
							border:none;
						}
						> div:nth-child(${props.activeIndex + 1}) {
							font-weight: 600;
							// border-bottom: 2px solid ${props.theme.COLOR_PRIMARY};
							color: ${props.theme.COLOR_PRIMARY};
							background: #fff;
						}
					`;
				}}
			`,
			Header: Styled.div.attrs({
				'data-widget': 'desk-tab-header'
			})`
				text-align: center;
				border-bottom: ${props => props.theme.BORDER};
				color: ${props => props.theme.FONT_COLOR_LIGHT2};
				transition: color 100ms ease-in-out;
				${props => this.renderCSS(props.theme)}
			`,
			Contents: Styled.div.attrs({
				'data-widget': 'desk-tab-contents'
			})`
				width: 100%;
				> div:nth-child(${(props: any) => props.activeIndex + 1}) {
					transition: opacity 100ms ease-in-out;
				}
				> div:not(:nth-child(${(props: any) => props.activeIndex + 1})) {
					z-index: 1;
					opacity: 0;
					display: none;
				}
				> div:nth-child(${(props: any) => props.activeIndex + 1}) {
					z-index: 10;
					opacity: 1;
				}
			`,
			Content: Styled.div.attrs({
				'data-widget': 'desk-tab-content'
			})`
				height: auto;
			`
		} as C;
	}
	protected renderTabHeaders(): JSX.Element {
		const { Headers, Header } = this.getComponents();
		return (
			<Headers
				count={this.getTitles().length}
				activeIndex={this.getActiveIndex()}
			>
				{this.getTitles().map((title: string, index: number) => {
					return (
						<Header
							className={this.getActiveIndex() === index ? 'active' : null}
							onClick={() => this.onHeaderClicked(index)}
							key={title}
						>
							<div>{title}</div>
						</Header>
					);
				})}
			</Headers>
		);
	}
	protected renderChildren(): any {
		const { Content, Contents } = this.getComponents();
		const activeIndex = this.getActiveIndex();
		return (
			<Contents
				count={this.getTitles().length}
				activeIndex={this.getActiveIndex()}
			>
				{React.Children.map(
					this.props.children,
					(child: any, index: number) => {
						return (
							<CSSTransition
								key={this.getTitles()[index]}
								in={activeIndex === index}
								classNames="slide"
								timeout={300}
							>
								<Content>{this.renderChild(child)}</Content>
							</CSSTransition>
						);
					}
				)}
			</Contents>
		);
	}
	render() {
		const { Box } = this.getComponents();
		return (
			<Box>
				{this.renderTabHeaders()}
				{this.renderChildren()}
			</Box>
		);
	}
	protected getTitles(): string[] {
		return this.props.titles || [];
	}
	protected getActiveIndex(): number {
		return this.state.index == null ? 0 : this.state.index!;
	}

	public setActiveIndex(actIndex: number): void {
		this.setState({
			index: actIndex
		});
	}

	protected onHeaderClicked(index: number): void {
		this.setState({ index });
		const headClick = this.getHeadClicked();
		if (Utils.isFunction(headClick)) {
			headClick({
				root: this.getRootModel(),
				model: this.getModel(),
				invoker: this,
				index
			});
		}
	}

	protected getHeadClicked() {
		return this.props.headClick;
	}

	protected triggerInitProcessEvent(): void {
		const listener = this.getInitProcessor();
		if (listener) {
			listener.call(this, {
				invoker: this,
				setActiveIndex: (actIndex: number) => this.setActiveIndex(actIndex)
			});
		}
	}
}

DeskComponentRegistry.register({
	tab: DeskTab
});

export { DeskTab };
